import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import form from './form.js'
import iframe from './iframe.js'
import prefBeta from './prefBeta.js'
import prefPreview from './prefPreview.js'

export default contract({
  form: array([
    form
  ]),
  iframe: array([
    iframe
  ]),
  prefBeta: array([
    prefBeta
  ]),
  prefPreview: array([
    prefPreview
  ]),
})
